import {ReliabilityEngineerPlantDashboard} from '@features/reliability-engineer-dashboard'
import {AnalysisListType} from '@hconnect/common/types/analysis.types'
import {getHProduceMyTasksUrl, getMaintainAnalysisListUrl} from '@hconnect/common/utils'
import {useCallback, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router'

import {
  ReliabilityAnalyticsEventName,
  useTrackReliabilityAnalyticsEvent
} from '../../../performanceDashboard/helpers'
import {useTranslationPrefix} from '../../../shared/hooks'
import {LocationBreadcrumbs} from '../../components'
import {
  getReliabilityEngineerStoppageAnalysisPagePath,
  getReliabilityEngineerPerformancePagePath,
  generateCockpitWorkOrdersLink
} from '../../utils'

type PathParameter = {
  plantId?: string
}

export const ReliabilityEngineerDashboard = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()
  const navigate = useNavigate()

  const myTasksHref = getHProduceMyTasksUrl()
  const maintainHref = getMaintainAnalysisListUrl(plantId, AnalysisListType.MyPlant)
  const cockpitWorkOrdersHref = generateCockpitWorkOrdersLink(plantId)

  const redirectToStoppageAnalysis = (equipmentId: string) => {
    void navigate(getReliabilityEngineerStoppageAnalysisPagePath(plantId, equipmentId))
  }

  const plantStatusPageHref = getReliabilityEngineerPerformancePagePath(plantId, 'yesterday')

  const trackReliabilityDashboard = useTrackReliabilityAnalyticsEvent()
  useEffect(() => {
    trackReliabilityDashboard(
      ReliabilityAnalyticsEventName.userEntersReliabilityEngineerDashboard,
      {}
    )
  }, [trackReliabilityDashboard])

  const trackUserViewsKmsWidgetEvent = useCallback(
    () => trackReliabilityDashboard(ReliabilityAnalyticsEventName.userViewsKmsWidget, {}),
    [trackReliabilityDashboard]
  )

  return (
    <ReliabilityEngineerPlantDashboard
      plantId={plantId}
      maintainHref={maintainHref}
      myTasksHref={myTasksHref}
      plantStatusPageHref={plantStatusPageHref}
      cockpitWorkOrdersHref={cockpitWorkOrdersHref}
      titleSlot={t(`${hrocPrefix}.reliabilityEngineerDashboard.pageTitle`)}
      aboveTitleSlot={<LocationBreadcrumbs />}
      onEquipmentClick={redirectToStoppageAnalysis}
      onUserViewsKmsWidget={trackUserViewsKmsWidgetEvent}
    />
  )
}
